import {
  Button,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import DataContext from "../../../../../../../../../context/DataContext";
import { useDebouncedEffect } from "../../../../../../../../../hooks/useDebounceEffect";
import axios from "../../../../../../../../api/axios";
import useToggleDropdown from "../../../../../../../../../hooks/useToggleDropdown";
import { Add, Remove } from "@mui/icons-material";
import ActiveFilterIndicator from "./ActiveFilterIndicator";

export default function SingleSelect({
  id,
  title,
  value,
  setValue,
  apiUrl,
  orderingVal,
  nameKey,
  valueKey,
  buttonFullW,
  dropdown,
  updateFilter,
  isActive,
  setActiveChipLabel
}) {
  const { accessToken } = useContext(DataContext);
  const [showForm, setShowForm] = useState(false);
  const [resLimit, setResLimit] = useState(100);
  const [showMoreVisible, setShowMoreVisible] = useState(true);
  const [responseArray, setResponseArray] = useState([]);
  const [labelMap, setLabelMap] = useState({});
  const [loadingRes, setLoadingRes] = useState(false);

  const accordionRef = useRef(null);

  useToggleDropdown(dropdown, accordionRef, () => setShowForm(false));

  const handleOnRadioBtnChange = (newValue) => {
    setValue(id, newValue, labelMap[newValue]);
    updateFilter(id, newValue);
    if(!newValue){
      localStorage.removeItem(id);
    }else{
      if(!localStorage.getItem(id) || localStorage.getItem(id) !== labelMap[newValue]){
        localStorage.setItem(id, labelMap[newValue]);
      }
      else{
        localStorage.removeItem(id);
      }
    }
    
  };


  useDebouncedEffect(
    () => {
      if (!apiUrl || !showForm) {
        return;
      } else {
        setLoadingRes(true);

        axios
          .get(
            `${apiUrl}&limit=${resLimit}&ordering=${
              !orderingVal ? "name" : orderingVal
            }`,
            {
              headers: { Authorization: `Token ${accessToken}` },
            }
          )
          .then((response) => {
            let data = response.data.results;
            if (data && data.length > 0) {
              let mapper = {};
              data.map((item) => {
                mapper[item[valueKey]] = item[nameKey];
              });
              setLabelMap(mapper);
              setActiveChipLabel(id, mapper[value]);
            }
            
            if (response.data.count <= resLimit) {
              setShowMoreVisible(false);
            } else {
              setShowMoreVisible(true);
            }
            setResponseArray(data);
            setLoadingRes(false);
          });
      }
    },
    [resLimit, showForm],
    250
  );
  return (
    <div ref={accordionRef} className="relative w-full bg-white mb-2">
      <div className="flex items-center">
        <Button
          onClick={() => setShowForm(!showForm)}
          className={`justify-between w-full text-left normal-case text-[16px] p-0 ${
            buttonFullW ? "w-full justify-between" : ""
          }`}
        >
          <div className="flex flex-row items-baseline">
            <span className="text-black pr-2">{title}</span>
            <span> {isActive && <ActiveFilterIndicator />}</span>
          </div>
          {!showForm ? (
            <Add className="text-sky-600 mr-2" />
          ) : (
            <Remove className="text-sky-600 mr-2" />
          )}
        </Button>
      </div>
      {!showForm ? (
        ""
      ) : (
        <div className="flex flex-row justify-evenly items-start">
          <div className="w-2/3">
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                className="text-sm"
                defaultValue={null}
                name="radio-buttons-group"
                value={value ?? ""}
                onChange={(e) => handleOnRadioBtnChange(e.target.value, value)}
              >
                {responseArray && responseArray.length > 0
                  ? responseArray.map((choice, idx) => (
                      <FormControlLabel
                        key={idx}
                        value={String(choice.key)}
                        control={<Radio />}
                        label={choice.label}
                        className="text-sm"
                      />
                    ))
                  : "No Selections Available"}
                <FormControlLabel
                  className="hidden text-sm"
                  value={""}
                  control={<Radio />}
                  label="hidden"
                />
              </RadioGroup>
            </FormControl>
          </div>
          <Button
            onClick={() => handleOnRadioBtnChange("")}
            variant="outlined"
            className="text-sm text-red-600 border-red-600 hover:bg-red-600 hover:text-white"
          >
            <span>Clear&nbsp;Filter</span>
          </Button>
        </div>
      )}
    </div>
  );
}